<template>
	<div>
		<div class="page-title">
			<icon-font class="title-icon" type="icon-Google" style="margin-right: 12px"/>
			<span>Google</span>
			<a-tooltip overlayClassName="question-tip" placement="topLeft" :title="updatePoint" v-if="updatePoint">
				<a-icon type="question-circle" class="update-point"/>
			</a-tooltip>
		</div>
		
		<!-- <a-tabs v-model="activeKey" type="card" class="page-tabs">
			<a-tab-pane key="account" tab="Google账号"></a-tab-pane>
			<a-tab-pane key="data" tab="Google数据"></a-tab-pane>
		</a-tabs> -->
		<div v-if="activeKey === 'account'">
			<MediaTab :tabData="tabData"></MediaTab>
		</div>
		<div v-if="activeKey === 'data'">
			<MediaData code="GG" @updatePoint="updatePoint = $event"></MediaData>
		</div>
	</div>
</template>
<script>
import MediaData from "./components/mediaData.vue"
import MediaTab from "./components/mediaTab.vue"

export default {
	name: 'Google',
	data() {
		return {
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
			tabData: {
				urlName: "google",
				platform: 2,
				code: 'GG'
			},
			updatePoint: ''
		}
	},
	methods: {
		openEC() {
			window.open('http://adpub.yeahtargeter.com/', '_blank')
		},
	},
	components: {
		MediaData,
		MediaTab
	}
}
</script>
<style lang="less" scoped>
	.page-tabs {
		margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
	.update-point {
		padding-left: 10px;
		font-size: 14px;
	}
</style>